// A logical clock for one question: did this read START after that thing happened?
//
// A read's answer says nothing about the moment it was SENT — a read that left before a payment was counted can come back after it, with the paid total as it was
// (Astra, 26 Oct, round 5: with the screen left and its query inactive, nothing cancels such a read, and its late arrival looked newer than the payment). So a read is stamped when
// it STARTS, and what happened in the page — a press that ended — is stamped from the same counter. Only a read whose stamp is LATER can be said to have seen it.
//
// A counter, not a time: it has no resolution for two moments to tie on and no wall clock to be set back, and two ticks are never equal. A page reload starts it again — and with it
// the query cache the stamps were compared in.

let ticks = 0;

/** The next tick: later than every tick before it, in this page. */
export const tick = (): number => ++ticks;

/** A read, stamped with the tick at which it STARTED — taken before the request leaves, so every answer that comes back carries the moment its question was asked. */
export function stamped<T extends object>(read: () => Promise<T>): Promise<T & { readTick: number }> {
  const readTick = tick();
  // An answer that is not an object (an empty body reads as undefined) is passed on as it is: the query then fails as it always did, rather than draw a cheque that has no deal.
  return read().then((r) => (r !== null && typeof r === 'object' ? { ...r, readTick } : r) as T & { readTick: number });
}
